export default __webpack_public_path__ + "static/media/fun-fact-thumb.a1977350.png";